import type { FC } from "react"

import { formatNumber } from "@/utils/number"

interface InventoryAdjustmentHistoryLotQtyChangeCellProps {
  qtyChange?: number | null
}

export const InventoryAdjustmentHistoryLotQtyChangeCell: FC<InventoryAdjustmentHistoryLotQtyChangeCellProps> = ({
  qtyChange,
}) => {
  if (qtyChange === null || qtyChange === undefined) return null
  const formatted = formatNumber(qtyChange, 2, 2)
  if (qtyChange > 0) {
    return <span className='font-medium text-green-600'>+{formatted}</span>
  }
  if (qtyChange < 0) {
    return <span className='font-medium text-red-600'>{formatted}</span>
  }
  return <span className='text-gray-700'>{formatted}</span>
}
